<template>
  <div id="score-report">
    <div class="md-layout mb-2">
      <div class="md-layout-item md-size-100 list-page-header">
        <h3 class="title text-2xl font-medium">
          {{ $t("task_management.task_management") }}
        </h3>
        <div
          class="primary-bulk-actions"
          v-if="$can(TaskManagement.actions.add, TaskManagement.subject)"
        >
          <ActionListButton
            :actions="bulkActions"
            :primaryBtnSettings="primaryAction"
          ></ActionListButton>
        </div>
      </div>
    </div>
    <div class="tabs border-t border-gray-300">
      <button
        v-for="(tab, idx) in tabs"
        :key="tab.name"
        :class="['tab-button', { active: currentTabIdx === idx }]"
        @click="currentTabIdx = idx"
      >
        {{ tab.label }}
      </button>

      <keep-alive>
        <component
          :is="tabs[currentTabIdx].component"
          class="tab"
          @updateTitle="updateTitle"
        ></component>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import AllList from "./AllList";
import OwnedByMe from "./OwnedByMe";
import ReportChart from "./ReportChart";
import ReportedByMe from "./ReportedByMe";
import ReviewedByMe from "./ReviewedByMe";
import ActionListButton from "@/components/Base/ActionListButton";
import { task_management } from "@/routes/routes";
import { TaskManagement } from "@/constants/Permissions";

export default {
  components: {
    ActionListButton
  },
  data() {
    return {
      TaskManagement,
      title: "",
      currentTabIdx: 0,
      primaryAction: {
        title: "common.add_new",
        onClick: () => {}
      },
      bulkActions: [
        {
          content: "task_management.add_main_task",
          action: () => {
            this.$router.push({ name: task_management.addMainTask });
          }
        },
        {
          content: "task_management.add_individual_task",
          action: () => {
            this.$router.push({ name: task_management.addIndividualTask });
          }
        }
      ]
    };
  },
  computed: {
    tabs() {
      let tabList = [
        {
          name: "reported-by-me",
          label: this.$t("task_management.assigned_to_me"),
          component: ReportedByMe
        },
        {
          name: "reviewed-by-me",
          label: this.$t("task_management.reviewed_by_me"),
          component: ReviewedByMe
        },
        {
          name: "report-chart",
          label: this.$t("task_management.report_chart"),
          component: ReportChart
        }
      ];
      if (this.$can(TaskManagement.actions.allList, TaskManagement.subject)) {
        tabList.unshift({
          name: "all-list",
          label: this.$t("task_management.all_task"),
          component: AllList
        });
      }
      if (this.$can(TaskManagement.actions.add, TaskManagement.subject)) {
        tabList.splice(tabList.length - 1, 0, {
          name: "owned-by-me",
          label: this.$t("task_management.owned_by_me"),
          component: OwnedByMe
        });
      }
      return tabList;
    }
  },
  methods: {
    updateTitle(value) {
      this.title = value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine";

.tab-button {
  @apply py-2 px-4;
  @apply text-gray-500 font-medium;
  @apply cursor-pointer;
  @apply outline-none;

  font-size: 1rem;

  &.active {
    border-top: 2px solid md-get-palette-color(purple, 500);
  }
}
</style>
